import { req } from 'react-reqq-lite';
import { formatSort, reqLoader } from 'helper';
import { toastSuccess } from 'react-geek-toast';
import { transformChannel, transformChannelBranch } from './transformers';
import * as c from './constants';

export const listChannels = (params) => {
  req.get({
    key: c.CHANNEL_LIST,
    url: '/admin/user_mng/v1/user',
    params: formatSort(params),
    transform: (res) => (res.data || []).map(transformChannel),
    onSuccess: (res) => {
      req.set(c.CHANNEL_PAGER, res?.response?.meta || {});
      req.set(c.CHANNEL_FILTER, params);
    },
  });
};

export const selectChannel = (id) => {
  req.get({
    key: c.CHANNEL_ITEM,
    url: `/admin/user_mng/v1/user/${id}`,
    transform: (res) => transformChannel(res.data),
  });
};

export const createChannel = (payload, onSuccess) => {
  req.post({
    key: c.CHANNEL_ITEM,
    url: '/admin/user_mng/v1/user',
    payload,
    onSuccess: (res, state) => {
      toastSuccess('Created!');
      setTimeout(() => {
        listChannels(state[c.CHANNEL_FILTER]);
      }, 1000);
      if (onSuccess) onSuccess(transformChannel(res?.response?.data));
    },
  });
};

export const updateChannel = (id, payload, onSuccess) => {
  req.put({
    key: c.CHANNEL_ITEM,
    url: `/admin/user_mng/v1/user/${id}/profile`,
    payload,
    onSuccess: (res, state) => {
      toastSuccess('Updated!');
      setTimeout(() => {
        listChannels(state[c.CHANNEL_FILTER]);
      }, 1000);
      selectChannel(id);
      if (onSuccess) onSuccess(transformChannel(res?.response?.data));
    },
  });
};

export const updateChannelEmail = (id, payload, onSuccess) => {
  req.put({
    key: c.CHANNEL_ITEM,
    url: `/admin/user_mng/v1/user/${id}`,
    payload,
    onSuccess: (res, state) => {
      toastSuccess('Updated!');
      setTimeout(() => {
        listChannels(state[c.CHANNEL_FILTER]);
      }, 1000);
      selectChannel(id);
      if (onSuccess) onSuccess(transformChannel(res?.response?.data));
    },
  });
};

export const removeChannel = (id, onSuccess) => {
  req.remove({
    key: c.CHANNEL_ITEM,
    url: `/admin/user_mng/v1/user/${id}`,
    onSuccess: (res, state) => {
      toastSuccess('Removed!');
      setTimeout(() => {
        listChannels(state[c.CHANNEL_FILTER]);
      }, 1000);
      req.set(c.CHANNEL_ITEM, null);
      if (onSuccess) onSuccess();
    },
  });
};

export const getCountCard = {
  total_transactions: () => {
    reqLoader(`${c.COUNT_CARD}/total_collections`, true);
    req.get({
      key: `${c.COUNT_CARD}/total_transactions`,
      url: '/admin/game_mng/v1/game',
      per_page: 0,
      onSuccess: (res) => {
        req.set(`${c.COUNT_CARD}/total_transactions`, {
          value: res?.response?.transaction_human,
        });
        req.set(`${c.COUNT_CARD}/total_collections`, {
          value: res?.response?.collection_human,
        });
        reqLoader(`${c.COUNT_CARD}/total_collections`, false);
      },
      onError: () => {
        reqLoader(`${c.COUNT_CARD}/total_collections`, false);
      },
    });
  },
};

/* CHANNEL BRANCH */
export const listChannelBranch = (params) => {
  req.get({
    key: c.CHANNEL_BRANCH_LIST,
    url: '/admin/game_mng/v1/category',
    params: formatSort(params),
    transform: (res) => (res?.data || []).map(transformChannelBranch),
    onSuccess: (res) => {
      req.set(c.CHANNEL_BRANCH_FILTER, params);
      req.set(c.CHANNEL_BRANCH_PAGER, res?.response?.meta || {});
    },
  });
};

export const createChannelBranch = (payload, onSuccess) => {
  req.post({
    key: c.CHANNEL_BRANCH_ITEM,
    url: '/admin/game_mng/v1/category',
    payload,
    onSuccess: (state) => {
      setTimeout(() => {
        listChannelBranch(state[c.CHANNEL_BRANCH_FILTER]);
      }, 1000);
      toastSuccess('Added!');
      onSuccess();
    },
  });
};

export const updateChannelBranch = (id, payload, onSuccess) => {
  req.put({
    key: c.CHANNEL_BRANCH_ITEM,
    url: `/admin/game_mng/v1/category/${id}`,
    payload,
    onSuccess: (state) => {
      setTimeout(() => {
        listChannelBranch(state[c.CHANNEL_BRANCH_FILTER]);
      }, 1000);
      toastSuccess('Updated!');
      onSuccess();
    },
  });
};

export const deleteChannelBranch = (id, onSuccess) => {
  req.remove({
    key: c.CHANNEL_BRANCH_ITEM,
    url: `/admin/game_mng/v1/category/${id}`,
    onSuccess: (state) => {
      setTimeout(() => {
        listChannelBranch(state[c.CHANNEL_BRANCH_FILTER]);
      }, 1000);
      toastSuccess('Deleted!');
      onSuccess();
    },
  });
};
/* CHANNEL BRANCH END */
